<svelte:options tag="user-feedback" />

<script>
  // Important notes:
  // 1. use node 17
  // 2. styles of every component need to be declared here
  // questions @tthoma
  import { _ } from "svelte-i18n";
  import { Modal, openModal, closeModal } from "renderless-svelte";
  import { CheckIcon } from "svelte-feather-icons";
  import { faFrown } from "@fortawesome/free-solid-svg-icons";
  import { createPopperActions } from "svelte-popperjs";
  import { fade } from "svelte/transition";
  import { Diamonds } from "svelte-loading-spinners";
  import Fa from "svelte-fa";

  import { addMessages, init, locale } from "svelte-i18n";
  import en from "./i18n/en.json";
  import el from "./i18n/el.json";

  import StarScale from "./StarScale.svelte";
  import TenScale from "./TenScale.svelte";
  import FreeText from "./FreeText.svelte";

  window.process = {
    env: {
      NODE_ENV: "production",
    },
  };

  export let openapp = "";
  export let client = "";
  export let name = "";
  export let surname = "";
  export let email = "";
  export let username = "";

  export let zindex = "50";
  export let halfmonthintervals = 1;
  export let headerheight = "0px";
  export let maincolor = "#2563eb";
  export let darkercolor = "#1e40af";
  export let modalmarginx = "0px";
  export let modalmarginy = "0px";
  export let modal = "true";
  let isModal = true;
  $: isModal = modal === "true";

  export let applocale = "el";
  $: $locale = applocale;
  // $: console.log("locale ", $locale);

  addMessages("en", en);
  addMessages("el", el);

  init({
    fallbackLocale: "el",
    initialLocale: applocale,
  });

  export let questions = [
    {
      question: $_("HOW_DO_YOU_RATE_APP"),
      type: "stars",
      obligatory: false,
    },
    {
      question: $_("HOW_DO_YOU_RATE_SUPPORT"),
      type: "stars",
      obligatory: false,
    },
    {
      question: $_("WILLINGNESS"),
      type: "tenScale",
      obligatory: false,
    },
    {
      question: $_("COMMENT"),
      type: "text",
      obligatory: false,
    },
  ];

  const resetQnA = () => {
    questions = questions.map((question) => {
      const base = { ...question };

      if (!base.id) base.id = crypto.randomUUID();

      if (base.type === "stars") {
        base.answer = -1;
        base.starsAreValid = null;
      } else if (base.type === "tenScale") {
        base.answer = -1;
        base.willingnessIsValid = null;
      } else if (base.type === "text") {
        base.answer = "";
        base.reviewIsValid = null;
        base.charsAreValid = null;
      }

      return base;
    });
  };

  function updateQuestion(index, newProps) {
    questions = questions.map((q, i) =>
      i === index ? { ...q, ...newProps } : q
    );
  }

  function handleStarsChange(i, newStars) {
    updateQuestion(i, { stars: newStars });
  }

  function handleWillingnessChange(i, newWillingness) {
    updateQuestion(i, { willingness: newWillingness });
  }

  function handleFreeTextChange(i, newReview) {
    updateQuestion(i, { review: newReview });
  }

  // Validation
  let isValid = null;

  let atLeastOneAnswered = false;
  let allValid = true;
  let hasObligatory = false;
  let showAllNonObligatoryMessage = false;
  const validation = function () {
    questions.forEach((q) => {
      const answered = q.type === "text" ? q.answer.length > 0 : q.answer != -1;

      if (q.obligatory) {
        hasObligatory = true;

        if (q.type === "stars") {
          q.starsAreValid = answered;
          if (!q.starsAreValid) {
            allValid = false;
          }
        } else if (q.type === "tenScale") {
          q.willingnessIsValid = answered;
          if (!q.willingnessIsValid) {
            allValid = false;
          }
        } else if (q.type === "text") {
          q.reviewIsValid = answered;
          q.charsAreValid = true; // always set to true
          if (!q.reviewIsValid || !q.charsAreValid) {
            allValid = false;
          }
        }
      } else {
        if (q.type === "stars") {
          q.starsAreValid = true;
        } else if (q.type === "tenScale") {
          q.willingnessIsValid = true;
        } else if (q.type === "text") {
          q.reviewIsValid = true;
          q.charsAreValid = true;
        }

        if (answered) {
          atLeastOneAnswered = true;
        }
      }
    });

    questions = [...questions];

    isValid = hasObligatory ? allValid : atLeastOneAnswered;

    if (!isValid && !hasObligatory && !atLeastOneAnswered) {
      showAllNonObligatoryMessage = true;
    } else {
      showAllNonObligatoryMessage = false;
    }
  };

  const [popperRef, popperContent] = createPopperActions();

  let arrowElement;

  const popperOptions = {
    modifiers: [
      { name: "offset", options: { offset: [3, 8] } },
      { name: "arrow", options: { element: arrowElement } },
    ],
  };

  let showTooltip = false;

  setTimeout(() => (showTooltip = true), 4000);

  const BASE_URL = "https://entrance2.open1.eu/entrance/api"; //Παραγωγικό 2
  // const BASE_URL = "https://entrance.open1.eu/entrance/api";
  // const BASE_URL = "https://entrance-staging.open1.eu/entrance/api";
  // const BASE_URL = "http://10.0.1.107:8103/tomokanga/api"; // Σοφία
  // const BASE_URL = "http://10.0.3.73:8103/tomokanga/api";  // Σταύρος
  // const BASE_URL = "http://10.0.2.48:8103/tomokanga/api"; // Κώστας

  // // Production process
  let serviceId = 2;
  let organizationId = 1; //OTS & Companies

  // Staging process
  // let serviceId = 195;
  // let organizationId = 6; //Ελαστός

  // if (serviceId == 99 && organizationId == 1) console.log("LOCAL");
  // else if (serviceId == 2 && organizationId == 1) console.log("PRODUCTIVE");

  // Periodically checks if systems are up and running (every 10 minutes)
  let isSystemUp;
  const checkAPIs = async () => {
    // console.log("kostas called checkapis");
    return new Promise(async (resolve, reject) => {
      fetch(BASE_URL + "/open1process/" + organizationId + "/systemIsUp", {
        method: "GET",
        headers: headers,
      })
        .then(function (response) {
          if (response.status !== 200) {
            console.log(
              "Looks like apis are down. Status Code: " + response.status
            );
            isSystemUp = false;
            reject();
          }
          // Examine the text in the response
          else {
            console.log("systems are up and running");
            isSystemUp = true;
            resolve();
          }
        })
        .catch(function (err) {
          console.log("Fetch Error :-S", err);
          isSystemUp = false;
          reject();
        });
    });
  };

  const checkAPIsRecursive = async () => {
    checkAPIs();

    window.setTimeout(checkAPIsRecursive, 600000); // check every 10 minute
  };

  $: isSystemUp = isSystemUp;

  checkAPIsRecursive();

  let modalIsHidden = true; //Boolean that manipulates the modal's visibility

  // You may modify the headers object here
  var headers = new Headers();
  headers.append("Content-Type", "application/json");

  if (window.location.href.indexOf("https://") === -1) {
    //running frontend locally
    headers.append("SessionID", "local-test-feedback");
  } else {
    //not developing locally, session info not available, set custom
    headers.append("SessionID", "feedback");
  }

  const openFeedBackModal = function () {
    openModal();
    resetQnA();
    showTooltip = false;
    modalIsHidden = false;
    needsToRate = false;
  };

  let element;
  function cancel() {
    element?.dispatchEvent(
      new CustomEvent("cancel", {
        bubbles: true, // usually you want this for event to bubble up
        composed: true, // so event crosses shadow DOM boundary if any
      })
    );
  }

  // Function to close the modal box and its background
  function close() {
    closeModal();
    resetQnA();
    modalIsHidden = true;
    isValid = null;
    req_status = null;
    errorWithProcess = false;
    isWaiting = false;
    needsToRate = false;
    cancel();
  }

  // Post data to API
  let req_status = null;
  let isWaiting = false;
  let errorWithProcess = false;

  // $: console.log("isWaiting: ", isWaiting);

  const startProcess = async () => {
    isWaiting = true;

    questions.forEach((q) => {
      if (q.type === "stars") {
        q.answer = parseInt(q.answer);
      } else if (q.type === "tenScale") {
        q.answer = parseInt(q.answer);
      }
    });

    // Set some attributes to request body first
    let request_body = {
      businessKey: "string",
      onBehalfOfDTO: {
        firstName: name,
        lastName: surname,
        emailAddress: email,
      },
      priority: "normal",
      registeredOrganizationId: organizationId,
      serviceId: serviceId,
      feedbackDTO: {
        client: client,
        openOneApp: openapp,
        questions: questions,
        username: username,
      },
    };

    // console.log("Request body before:", request_body);

    if (username != "") {
      request_body.businessKey =
        "Αξιολόγηση > " +
        client +
        " ( " +
        username +
        " " +
        request_body.onBehalfOfDTO.firstName +
        " " +
        request_body.onBehalfOfDTO.lastName +
        " ) ";
      request_body.feedbackDTO.username = username;
    } else {
      request_body.businessKey =
        "Αξιολόγηση > " +
        client +
        " ( " +
        request_body.onBehalfOfDTO.firstName +
        " " +
        request_body.onBehalfOfDTO.lastName +
        " ) ";
    }

    // console.log("Request body after:", request_body);

    const res = await fetch(BASE_URL + "/open1process/processes/start", {
      method: "POST",
      headers: headers,
      body: JSON.stringify(request_body),
    });

    const response = await res.json();
    return response;
  };

  const go = () => {
    startProcess().then((res) => {
      req_status = res.status;
      console.log(res);
      if (res.status === "OK") {
        isWaiting = false;
        console.log("error undefined");
        //If status OK, see if we have errors
        if (res.errors.length > 0) {
          console.log("An error occured" + ": " + res.data.errors);
          errorWithProcess = true;
          console.log("error primary");
        } else {
          // no errors, move to next and final step
          console.log("error none");
          console.log("Success!");
          errorWithProcess = false;
          needsToRate = false;
          // lastRated = Date.now();
          // localStorage.setItem("lastRated", lastRated);
        }
      } else {
        console.log("error 1");
        isWaiting = false;
        errorWithProcess = true;
      }
    });
  };

  // Notification
  let lastRated;
  let needsToRate;

  // $: localStorage.setItem("needsToRate", needsToRate);

  let waitingForLatestFeedback = false;
  let errorGettingLatestFeedBack = false;

  const getFeedbackNewerDateIfAny = async () => {
    waitingForLatestFeedback = true;

    const response = await fetch(
      BASE_URL +
        "/open1process/" +
        organizationId +
        "/feedbackDate?" +
        "client=" +
        client +
        "&username=" +
        username +
        "&openOneApp=" +
        openapp,
      {
        method: "GET",
        headers: headers,
      }
    );
    return response.json(); // parses JSON response into native JavaScript objects
  };

  const returnLatestFeedbackDateAsTimestamp = () => {
    return new Promise(async (resolve, reject) => {
      let latestFeedbackDate;
      let latestFeedbackDateTimestamp;
      getFeedbackNewerDateIfAny()
        .then((response) => {
          // console.log(response);
          if (response.status !== "OK") {
            console.log(
              "Looks like there was a problem. Status Code: " + response.status
            );
            waitingForLatestFeedback = false;
            errorGettingLatestFeedBack = true;
            reject();
          }
          // Examine data in the response
          else if (response.status === "OK") {
            //If status OK, see if we have errors
            if (response.errors.length > 0) {
              console.log(
                "Looks like there was a problem. Error: " + response.errors[0]
              );
              waitingForLatestFeedback = false;
              errorGettingLatestFeedBack = true;
              reject();
            } else {
              //everything is OK
              // if there are previous ratings submitted
              if (response.data.length > 0) {
                latestFeedbackDate = response.data[0].processInstanceStartDate;
                latestFeedbackDateTimestamp = new Date(
                  latestFeedbackDate
                ).getTime();
              } else {
                //no ratings have been submitted
                latestFeedbackDateTimestamp = null;
              }
              waitingForLatestFeedback = false;
              errorGettingLatestFeedBack = false;
              resolve(latestFeedbackDateTimestamp);
            }
          } else {
            console.log(
              "Looks like there was a problem. Status Code: " + response.status
            );
            waitingForLatestFeedback = false;
            errorGettingLatestFeedBack = true;
            reject();
          }
        })
        .catch(function (err) {
          console.log("Fetch Error :-S", err);
          waitingForLatestFeedback = false;
          errorGettingLatestFeedBack = true;
          reject();
        });
    });
  };

  const checkRating = () => {
    // console.log("called checkRating");
    //find interval between last feedback submission and current date
    let today = Date.now();
    let latestFeedbackAlertDate = null;

    try {
      latestFeedbackAlertDate = localStorage.getItem("latestFeedbackAlertDate");
    } catch (error) {
      console.log(
        "error while getting latestFeedbackAlertDate from localStorage"
      );
    }

    returnLatestFeedbackDateAsTimestamp().then((feedbackTimestamp) => {
      if (feedbackTimestamp) {
        //if there are previous ratings, check
        if (today - feedbackTimestamp > 1296000000 * halfmonthintervals) {
          if (
            latestFeedbackAlertDate !=
            new Date(today).toISOString().slice(0, 10)
          ) {
            needsToRate = true;
          } else {
            needsToRate = false;
          }
        } else {
          needsToRate = false;
        }
      } else {
        //if there are no previous ratings submitted, prompt user to rate
        if (
          latestFeedbackAlertDate != new Date(today).toISOString().slice(0, 10)
        ) {
          needsToRate = true;
        } else {
          needsToRate = false;
        }
      }

      try {
        localStorage.setItem(
          "latestFeedbackAlertDate",
          new Date(today).toISOString().slice(0, 10)
        );
      } catch (error) {
        console.log(
          "error while setting latestFeedbackAlertDate in localStorage"
        );
      }
    });
    // Half month in milliseconds * intervals needed; eg. 1296000000 * 3 = 1.5 month
  };

  //only allow for rating checks if all client and org info has been read from prompts
  $: if (organizationId && client && username && openapp) checkRating();

  $: if (zindex) {
    zindex = parseInt(zindex);
    const root = document.documentElement;
    root.style.setProperty("--zindex", zindex);
    root.style.setProperty("--zindexbg", zindex - 1);
  }

  $: if (maincolor || darkercolor) {
    const root = document.documentElement;
    root.style.setProperty("--maincolor", maincolor);
    root.style.setProperty("--darkercolor", darkercolor);
  }

  $: if (headerheight) {
    const root = document.documentElement;
    root.style.setProperty("--headerheight", headerheight);
  }

  $: if (modalmarginx || modalmarginy) {
    const root = document.documentElement;
    root.style.setProperty("--modalmarginx", modalmarginx);
    root.style.setProperty("--modalmarginy", modalmarginy);
  }

  $: if (!isModal) openFeedBackModal();
</script>

<!-- Listener for when the Esc button is pressed; closes the modal -->
<svelte:window on:keyup={(ev) => ev.key === "Escape" && close()} />

{#if isModal}
  <div class="w-max">
    <div class="flex flex-row">
      <div use:popperRef>
        <slot
          name="button"
          on:click={() => {
            openFeedBackModal();
          }}
        />

        {#if !$$slots.notification && showTooltip && needsToRate}
          <div
            class="tooltip fade-in"
            on:click={() => {
              openFeedBackModal();
            }}
            use:popperContent={popperOptions}
          >
            <div style="display:flex;">
              <div class="animate-bounce">⭐</div>
              {#if $$slots.tooltip}
                &nbsp;
                <slot name="tooltip" />
              {/if}
            </div>

            <div bind:this={arrowElement} class="arrow" />
          </div>
        {/if}
      </div>
      <slot name="notification" class:hidden={!needsToRate} />
    </div>

    <!-- The background behind the modal -->
    <div
      id="background"
      class="h-screen fixed opacity-80 bg-black inset-0"
      class:hidden={modalIsHidden}
      on:click={close}
    />

    <!-- The modal containing the details of the clicked service -->
    <div
      id="modal-box"
      class="!text-gray-800"
      class:!hidden={modalIsHidden}
      style="font-family: Roboto, sans-serif"
    >
      <Modal>
        <div class="wrapper">
          <header />

          <!-- The x button of the modal -->
          <!-- <button
            class="absolute z-3 -top-20px -right-19.5px px-8px leading-tight
        rounded-full border-0 hover:bg-gray-300 cursor-pointer flex items-center
        h-40px <md:(hidden) text-24px"
            class:hidden={modalIsHidden}
            on:click={close}
          >
            <svg
              xmlns="http://www.w3.org/2000/svg"
              width="24"
              height="24"
              viewBox="0 0 24 24"
              fill="none"
              stroke="currentColor"
              stroke-width="2"
              stroke-linecap="round"
              stroke-linejoin="round"
            >
              <line x1="18" y1="6" x2="6" y2="18" />
              <line x1="6" y1="6" x2="18" y2="18" />
            </svg>
          </button> -->

          <!-- The modal box -->
          <div class="overflow-y-auto px-28px py-12px text-20px">
            {#if !isWaiting && !req_status}
              {#each questions as question, i (question.id)}
                {#if question.type == "stars"}
                  <StarScale
                    id={question.id}
                    question={question.question}
                    bind:stars={question.answer}
                    onStarsChange={(j, newStars) => {
                      handleStarsChange(j, newStars);
                    }}
                    bind:starsAreValid={question.starsAreValid}
                    {maincolor}
                    {darkercolor}
                  />
                {/if}

                {#if question.type == "tenScale"}
                  <TenScale
                    id={question.id}
                    question={question.question}
                    bind:willingness={question.answer}
                    onWillingnessChange={(j, newWillingness) => {
                      handleWillingnessChange(j, newWillingness);
                    }}
                    bind:willingnessIsValid={question.willingnessIsValid}
                    {maincolor}
                    {darkercolor}
                  />
                {/if}

                {#if question.type == "text"}
                  <FreeText
                    id={question.id}
                    question={question.question}
                    bind:review={question.answer}
                    onFreeTextChange={(j, newReview) => {
                      handleFreeTextChange(j, newReview);
                    }}
                    bind:reviewIsValid={question.reviewIsValid}
                    bind:charsAreValid={question.charsAreValid}
                    {maincolor}
                    {darkercolor}
                  />
                {/if}
              {/each}
            {:else if isWaiting}
              <div
                in:fade={{ delay: 800 }}
                class="fade-in-up flex flex-col items-center text-center mt-50px"
              >
                <div class="my-5px text-20px">{$_("SUBMITTING")}</div>
                <div class="mt-8 text-30px">
                  <Diamonds
                    size="6"
                    color={maincolor}
                    unit="rem"
                    duration="2s"
                  />
                </div>
              </div>
            {:else if errorWithProcess}
              <div
                class="fade-in-up flex flex-col items-center text-center mt-50px"
              >
                <div class="mb-10px text-$maincolor text-30px">
                  <Fa icon={faFrown} size="4x" aria-hidden="true" />
                </div>
                <div class="my-5px text-20px">{$_("PROBLEM")}</div>
                <div class="my-5px text-20px">{$_("TRY_AGAIN")}</div>
                <div class="hidden">
                  {setTimeout(function () {
                    close();
                  }, 2000)}
                </div>
              </div>
            {:else}
              <div
                class="fade-in-up flex flex-col items-center text-center mt-50px"
              >
                <div class="mb-10px text-green-700 text-30px">
                  <CheckIcon size="150" />
                </div>
                <div class="my-5px text-20px">{$_("THANK_YOU")}</div>
                <div class="hidden">
                  {setTimeout(function () {
                    close();
                  }, 2000)}
                </div>
              </div>
            {/if}

            <!-- The footer of the modal; contains operating buttons to connect into the service, close the modal
      or print the service's description -->
            <div class="pt-30px w-full">
              <div class="flex flex-row">
                {#if req_status == null}
                  <button
                    class="generic-btn action-btn mt-5px mr-8px cursor-pointer"
                    class:hidden={isValid}
                    on:click={() => {
                      validation();
                      if (isValid) {
                        go();
                      }
                    }}
                  >
                    <span>{$_("SUBMIT")}</span>
                  </button>

                  <button
                    class="generic-btn mt-5px hover:bg-gray-100 cursor-pointer
              !text-gray-800"
                    on:click={close}
                    class:hidden={isValid}
                  >
                    {$_("CANCEL")}
                  </button>
                {/if}
              </div>
            </div>
          </div>
        </div>
      </Modal>
    </div>
  </div>
{:else}
  <div class="overflow-y-auto px-28px py-12px text-20px">
    {#if !isWaiting && !req_status}
      {#each questions as question, i (question.id)}
        {#if question.type == "stars"}
          <StarScale
            id={question.id}
            question={question.question}
            bind:stars={question.answer}
            onStarsChange={(j, newStars) => {
              handleStarsChange(j, newStars);
            }}
            bind:starsAreValid={question.starsAreValid}
            {maincolor}
            {darkercolor}
          />
        {/if}

        {#if question.type == "tenScale"}
          <TenScale
            id={question.id}
            question={question.question}
            bind:willingness={question.answer}
            onWillingnessChange={(j, newWillingness) => {
              handleWillingnessChange(j, newWillingness);
            }}
            bind:willingnessIsValid={question.willingnessIsValid}
            {maincolor}
            {darkercolor}
          />
        {/if}

        {#if question.type == "text"}
          <FreeText
            id={question.id}
            question={question.question}
            bind:review={question.answer}
            onFreeTextChange={(j, newReview) => {
              handleFreeTextChange(j, newReview);
            }}
            bind:reviewIsValid={question.reviewIsValid}
            bind:charsAreValid={question.charsAreValid}
            {maincolor}
            {darkercolor}
          />
        {/if}
      {/each}
    {:else if isWaiting}
      <div
        in:fade={{ delay: 800 }}
        class="fade-in-up flex flex-col items-center text-center mt-50px"
      >
        <div class="my-5px text-20px">{$_("SUBMITTING")}</div>
        <div class="mt-8 text-30px">
          <Diamonds size="6" color={maincolor} unit="rem" duration="2s" />
        </div>
      </div>
    {:else if errorWithProcess}
      <div class="fade-in-up flex flex-col items-center text-center mt-50px">
        <div class="mb-10px text-$maincolor text-30px">
          <Fa icon={faFrown} size="4x" aria-hidden="true" />
        </div>
        <div class="my-5px text-20px">{$_("PROBLEM")}</div>
        <div class="my-5px text-20px">{$_("TRY_AGAIN")}</div>
        <div class="hidden">
          {setTimeout(function () {
            close();
          }, 2000)}
        </div>
      </div>
    {:else}
      <div class="fade-in-up flex flex-col items-center text-center mt-50px">
        <div class="mb-10px text-green-700 text-30px">
          <CheckIcon size="150" />
        </div>
        <div class="my-5px text-20px">{$_("THANK_YOU")}</div>
        <div class="hidden">
          {setTimeout(function () {
            close();
          }, 2000)}
        </div>
      </div>
    {/if}

    {#if showAllNonObligatoryMessage}
      <div class="text-red-500 text-center mt-4">
        {$_("PLEASE_ANSWER_AT_LEAST_ONE_QUESTION")}
      </div>
    {/if}

    <!-- The footer of the modal; contains operating buttons to connect into the service, close the modal
      or print the service's description -->
    <div class="pt-30px w-full">
      <div class="flex flex-row">
        {#if req_status == null}
          <button
            class="generic-btn action-btn mt-5px mr-8px cursor-pointer"
            class:hidden={isValid}
            on:click={() => {
              validation();
              if (isValid) {
                go();
              }
            }}
          >
            <span>{$_("SUBMIT")}</span>
          </button>

          <button
            bind:this={element}
            class="generic-btn mt-5px hover:bg-gray-100 cursor-pointer
              !text-gray-800"
            on:click={close}
            class:hidden={isValid}
          >
            {$_("CANCEL")}
          </button>
        {/if}
      </div>
    </div>
  </div>
{/if}

<style windi:preflights:global windi:safelist:global>
  .custom-hr {
    @apply border-0 bg-gray-300 h-1px;
  }

  .generic-btn {
    @apply py-16px px-16px bg-white border-solid border-gray-100 text-20px rounded-xl;
  }

  .generic-btn:active {
    transform: scale(0.95);
  }

  .action-btn {
    @apply border-1 cursor-pointer border-solid bg-$darkercolor border-$darkercolor text-20px text-white hover:bg-$maincolor hover:border-$maincolor;
  }

  .wrapper {
    @apply min-h-full grid grid-rows-[auto,1fr,auto];
  }

  #background {
    z-index: var(--zindexbg);
    @apply <md:(mt-$headerheight);
  }

  #modal-box {
    z-index: var(--zindex);
    @apply flex flex-col bg-white fixed text-left rounded-8px min-h-19/25 inset-0 mx-auto
    xl:(my-30px max-h-full max-w-750px) @lg:(my-30px max-w-660px) @md:(my-30px min-w-660px) <md:(m-auto mx-$modalmarginx my-$modalmarginy min-w-1/3);
  }

  .fade-in-up {
    animation: fadeinup 0.6s;
  }
  @keyframes fadeinup {
    from {
      opacity: 0;
      transform: translateY(20px);
    }
    to {
      opacity: 1;
    }
  }

  .fade-in {
    animation: fadein 0.6s;
  }
  @keyframes fadein {
    from {
      opacity: 0;
    }
    to {
      opacity: 1;
    }
  }

  .tooltip {
    box-shadow: 0px 8px 20px -4px rgba(114, 130, 137, 0.1);
    background: black;
    border-radius: 12px;
    padding: 16px;
    position: absolute;
    color: white;
    width: auto;
    font-size: 20px;
    cursor: pointer;
  }

  .arrow,
  .arrow::before {
    position: absolute;
    width: 8px;
    height: 8px;
    background: inherit;
  }

  .arrow {
    visibility: hidden;
  }

  .arrow::before {
    visibility: visible;
    content: "";
    transform: rotate(45deg);
  }

  .tooltip[data-popper-placement^="top"] > .arrow {
    bottom: -4px;
  }

  .tooltip[data-popper-placement^="bottom"] > .arrow {
    top: -4px;
  }

  .tooltip[data-popper-placement^="left"] > .arrow {
    right: -4px;
  }

  .tooltip[data-popper-placement^="right"] > .arrow {
    left: -4px;
  }

  .pulse {
    animation: pulse 1s infinite ease-in-out alternate;
  }
  @keyframes pulse {
    from {
      transform: scale(0.8);
    }
    to {
      transform: scale(1.2);
    }
  }
</style>
